import { toNumber } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Box, Button, Dialog, IconMapMarker, List, Stack, Text } from '@machobear/design-system'

const VerifyAddressModal = ({ listingData, onGetSupport, handleSuccessEvent, open, onClose }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { listings, unit, building } = listingData

  const onConfirm = async () => {
    await dispatch.listing.requestVerifyCode({
      listingId: toNumber(listings.id)
    })
    handleSuccessEvent()
    onClose()
  }

  const onRequestSupport = () => {
    onGetSupport()
    onClose()
  }

  const unitNumber = unit?.unit_number ? `${unit.unit_number} - ` : ''
  const fullAddress = `${unitNumber}${building?.full_address}`

  return (
    <Dialog
      id="ConfirmAddressModal"
      title={t('l.verify_listing.view.confirm_address.title', 'Confirm your address')}
      open={open}
      onClose={onClose}
    >
      <Stack space="large">
        <Text tone="secondary">
          {t(
            'l.verify_listing.view.confirm_address.text',
            `Please review the address below to ensure it is correct:`
          )}
        </Text>
        <Box
          display="flex"
          alignItems="center"
          borderRadius="small"
          border="borderNeutralLight"
          padding="small"
          background="neutralLight"
        >
          <Box marginRight="xsmall">
            <IconMapMarker tone="tertiary" size="medium" />
          </Box>
          <Text weight="strong">{fullAddress}</Text>
        </Box>
        <Stack space="small">
          <Text tone="secondary" weight="medium">
            {t('l.verify_listing.view.whats_next.title', "What's next?")}
          </Text>
          <List type="number" space="xsmall">
            <Text>
              {t(
                'l.verify_listing.view.whats_next.list_1',
                'We will send a postcard to this address within 5-10 business days.'
              )}
            </Text>
            <Text>
              {t(
                'l.verify_listing.view.whats_next.list_2',
                'Enter the 6-digit code from the postcard to verify your listing.'
              )}
            </Text>
          </List>
        </Stack>
        <Box display="flex" justifyContent="flexEnd">
          <Box paddingX="xsmall" style={{ minWidth: 'fit-content' }}>
            <Button variant="transparent" onClick={onRequestSupport}>
              {t('l.verify_listing.view.no_support.button', 'Get support')}
            </Button>
          </Box>
          <Box style={{ minWidth: 'fit-content' }}>
            <Button variant="solid" onClick={onConfirm}>
              {t('l.verify_listing.view.yes_confirm.button', 'I confirm')}
            </Button>
          </Box>
        </Box>
      </Stack>
    </Dialog>
  )
}

export default VerifyAddressModal
